export default __webpack_public_path__ + "static/media/Ellipse 24.da668464.png";